export default __webpack_public_path__ + "static/media/SocialDesktop.ab96c6df.png";